module.exports = "<admin-user></admin-user>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/app/admin/user/admin-user/admin-user.component.html
// module id = ./src/components/app/admin/user/admin-user/admin-user.component.html
// module chunks = main